export const microsoftGraphKeysSettingDuplicitValidationFrag = `
    id
    dateTo
`;
